import { VirtualKeyboardButton, VirtualKeyboardButtonSize, VirtualKeyboardLayout } from '@cue/navigation-services';

function createCharacterKey(defaultValue: string, className?: string): VirtualKeyboardButton {
  return {
    defaultValue,
    ctrlValue: defaultValue,
    buttonSize: VirtualKeyboardButtonSize.Default,
    class: className,
  };
}

export function getVirtualKeyboardDecimalSeparator(locale: string): string {
  try {
    return new Intl.NumberFormat(locale).formatToParts(1.1).find((part) => part.type === 'decimal')?.value ?? '.';
  } catch {
    return '.';
  }
}

export function createNumericKeyboardLayout(decimalSeparator: string): VirtualKeyboardLayout {
  return {
    firstRow: [
      createCharacterKey('7'),
      createCharacterKey('8'),
      createCharacterKey('9'),
      {
        defaultValue: 'Backspace',
        buttonSize: VirtualKeyboardButtonSize.Default,
        isDeleteFn: true,
      },
    ],
    secondRow: [createCharacterKey('4'), createCharacterKey('5'), createCharacterKey('6'), createCharacterKey('-')],
    thirdRow: [
      createCharacterKey('1'),
      createCharacterKey('2'),
      createCharacterKey('3'),
      {
        defaultValue: 'Enter',
        buttonSize: VirtualKeyboardButtonSize.Default,
        isEnterFn: true,
      },
    ],
    fourthRow: [createCharacterKey('0', 'numeric-zero'), createCharacterKey(decimalSeparator)],
    fifthRow: [],
  };
}
